const palette = {
  coral: {
    medium: "#FE7C73",
  },
  white: {
    lightest: "rgba(247,247,255,0.66)",
    medium: "#F7F7FF",
  },
  aqua: {
    medium: "#BDD5EA",
  },
  blue: {
    lightest: "#ECEDFE",
    lighter: "#BFC3F9",
    light: "#737CEF",
    medium: "#545FEC",
    dark: "#545FEC",
  },
  green: {
    lightest: "#E1F4E8",
    lighter: "#AAEEAE",
    light: "#9EEBA2",
    medium: "#89E78E",
    dark: "#019564",
  },
  grey: {
    lightest: "#ECEDED",
    lighter: "#CED1D3",
    light: "#B3B7BA",
    mediumLight: "#666e74",
    medium: "#2F3942",
    dark: "#161A1E",
  },
  yellow: {
    lightest: "#FFEFD6",
    light: "#FFE6BE",
    medium: "#FFC972",
  },
  orange: {
    light: "#E07A5F",
    medium: "#E07A5F",
  },
  red: {
    lightest: "#F8E2DE",
    light: "#F97566",
    medium: "#D63939",
    dark: "#9F593B",
  },
  purple: {
    lighter: "#EFEDFE",
    light: "#E4DFFF",
    medium: "#BBAFFF",
    dark: "#2F276B",
  },
};

export const theme = {
  palette,
  section: {
    background: {
      primary: palette.blue.medium,
      blue: palette.blue.medium,
      yellow: palette.yellow.medium,
      grey: palette.grey.medium,
      red: palette.red.medium,
    },
  },
  text: {
    colour: palette.grey.medium,
    inverted: {
      colour: palette.white.medium,
    },
  },
  headings: {
    margin: "12px 0",
    tablet: {
      maxWidth: "768px",
    },
    desktop: {
      maxWidth: "10240px",
    },
  },
  logo: {
    inverted: {
      colour: palette.grey.medium,
    },
    colour: palette.white.medium,
  },
  hr: {
    colour: palette.grey.lightest,
  },
  button: {
    primary: {
      colour: palette.white.medium,
      background: palette.blue.medium,
      disabled: palette.blue.lightest,
    },
    secondary: {
      colour: palette.blue.medium,
      background: palette.white.medium,
      borderColour: palette.blue.light,
      disabled: palette.white.lightest,
    },
    tertiary: {
      colour: palette.blue.medium,
      background: palette.white.medium,
      disabled: palette.blue.lightest,
    },
    external: {
      colour: palette.grey.medium,
      background: palette.green.medium,
      disabled: palette.green.lightest,
    },
    danger: {
      colour: palette.grey.medium,
      background: palette.yellow.medium,
    },
  },
  shadow: "rgba(47, 57, 66, 0.2) 2px 0px 8px",
  card: {
    background: "#ffffff",
    border: palette.grey.lightest,
    borderRadius: "4px",
    positive: {
      background: palette.green.light,
      borderRadius: "4px 0 0 4px",
    },
    negative: {
      background: palette.grey.lightest,
      borderRadius: "0 4px 4px 0",
    },
  },
  footer: {
    background: palette.grey.medium,
  },
  onboarding: {
    background: palette.grey.medium,
    accent: palette.yellow.medium,
  },
  input: {
    borderColour: palette.grey.light,
    valid: {
      borderColour: palette.green.medium,
    },
    focus: {
      borderColour: palette.grey.medium,
    },
    error: {
      colour: palette.red.medium,
      borderColour: palette.red.medium,
    },
  },
};
